 const IncoPhaseIds = {
    BACKLOG: 1,
    PLANNING: 2,
    EXECUTION: 3,
    CLOSED: 4,
    CANCELLED: 5,
} as const;

export const NON_EDITABLE_PHASE_IDS: readonly number[] = [
    IncoPhaseIds.BACKLOG,
    IncoPhaseIds.CLOSED,
    IncoPhaseIds.CANCELLED,
];

export function isPhaseNonEditable(phaseId: number | null | undefined): boolean {
    if (phaseId == null) {
        return false;
    }
    return NON_EDITABLE_PHASE_IDS.includes(phaseId);
}

export function isPhaseEditableForPlanning(phaseId: number | null | undefined): boolean {
    if (phaseId == null) {
        return false;
    }
    return phaseId === IncoPhaseIds.PLANNING || phaseId === IncoPhaseIds.EXECUTION;
}

export function isPhaseEditableForExecution(phaseId: number | null | undefined): boolean {
    if (phaseId == null) {
        return false;
    }
    return phaseId === IncoPhaseIds.EXECUTION;
}

